export const PAGE_LINKS_WITH_IDS = [
  { link: "/", id: "home" },
  { link: "/agronomos", id: "agronomos" },
  { link: "/agronomos/add", id: "agronomosadd" },
  { link: "/agronomos/:id", id: "agronomosedit" },
  { link: "/agronomos/edit/:id", id: "agronomoseditcrea" },
  { link: "/arts", id: "arts" },
  { link: "/arts/add", id: "artsadd" },
  { link: "/arts/:id", id: "artsedit" },
  { link: "/creas/:id", id: "creasedit" },
  { link: "/creas/add/:id", id: "creasadd" },
  { link: "/compendio", id: "compendio" },
  { link: "/contracts/:id", id: "contracts_edit" },
  { link: "/compra/sucesso", id: "compra_sucesso" },
  { link: "/compra/sucesso/compra-5", id: "comprasucessocompra5" },
  { link: "/compra/sucesso/compra-4", id: "comprasucessocompra4" },
  { link: "/compra/sucesso/compra-7", id: "comprasucessocompra7" },
  { link: "/compra/sucesso/compra-6", id: "comprasucessocompra6" },
  { link: "/compra", id: "compra" },
  { link: "/devolucoes", id: "devolucoes" },
  { link: "/devolucoes/add", id: "devolucoesadd" },
  { link: "/devolucoes/:id", id: "devolucoesedit" },
  { link: "/editcontract/:id", id: "editcontract" },
  { link: "/documentos_seguranca", id: "documentosseguranca" },
  { link: "/empresa", id: "empresa" },
  { link: "/filiais", id: "filiais" },
  { link: "/filiais/add", id: "filiaisadd" },
  { link: "/filiais/:id", id: "filiaisedit" },
  { link: "/fazendas/edit/:idfazenda/:idprodutor", id: "fazendasedit" },
  { link: "/fazendas/:idfazenda/:idprodutor", id: "fazendasview" },
  { link: "/fazendas", id: "fazendas" },
  { link: "/historico", id: "historico" },
  { link: "/localdeaplicacao/add/:id", id: "localdeaplicacaoadd" },
  { link: "/newcontract/:id", id: "newcontract" },
  { link: "/notificacao", id: "notificacao" },
  { link: "/produtores", id: "produtores" },
  { link: "/produtores/add", id: "produtoresadd" },
  { link: "/produtores/:id", id: "produtoresedit" },
  { link: "/novo-produtores", id: "produtores" },
  { link: "/plano/edit", id: "planoedit" },
  { link: "/relatorios", id: "relatorios" },
  { link: "/solicitar", id: "solicitar" },
  { link: "/usuarios/add", id: "usuariosadd" },
  { link: "/usuarios", id: "usuarios" },
  { link: "/usuarios/:id", id: "usuariosedit" },
  { link: "/simulacao/:id", id: "simulacao" },
  { link: "/extras/nova_receita", id: "extrasnovareceita" },
  { link: "/receitas/add", id: "receitasadd" },
  { link: "/receitas/lote", id: "receitaslote" },
  { link: "/comprar_receitas", id: "comprarreceitas" },
  { link: "/comprar_limite", id: "comprarlimite" },
  { link: "/faturamento", id: "faturamento" },
  { link: "/integracao", id: "integracao" },
  { link: "/guia_aplicacao", id: "guiaaplicacao" },
  { link: "/blog", id: "blog" },
  { link: "/cupom-indique-e-ganhe", id: "cupomindiqueganhe" },
  { link: "/exportar-defesas", id: "exportardefesas" },
  { link: "/exportar-defesas/:uf", id: "exportardefesas_details" },
  { link: "/caderno-campo", id: "cadernocampo" },
  { link: "/nova-home/apresentacao", id: "homeapresentacao" },
  { link: "/indique-e-ganhe", id: "indiqueganhe" },
  { link: "/compendio-gratis", id: "compendiogratis" },
  { link: "/cadastro", id: "cadastro" },
  { link: "/cadastro/site", id: "cadastrosite" },
  { link: "/cadastro/free", id: "cadastrofree" },
  { link: "/cadastro/sucesso", id: "cadastrosucesso" },
  { link: "/apresentacao", id: "apresentacao" },
  { link: "/validador", id: "validador" },
  { link: "/linkedin/login", id: "linkedinlogin" },
  { link: "/receituario-agronomico-2026", id: "lpa-receituario2026" },
  { link: "/receituario-agronomico-2026b", id: "lpb-receituario2026" },
  { link: "/lp-indique-e-ganhe", id: "lpindiqueganhe" },
  { link: "/planos", id: "planos" },
  { link: "/login-compra/:id", id: "logincompra" },
  { link: "/login", id: "login" },
  { link: "/cadastro-completo", id: "cadastrocompleto" },
  { link: "/cadastro-email", id: "cadastroemail" },
  { link: "/senha/:ticket", id: "senha" },
  { link: "/simulacaoplano/:id", id: "simulacaoplano" },
  { link: "/lgpd", id: "lgpd" },
];

const normalizePath = (path = "/") => {
  const pathWithoutHash = String(path || "").split("#")[0];
  const pathWithoutQuery = pathWithoutHash.split("?")[0];
  let normalized = decodeURIComponent(pathWithoutQuery || "/").trim();

  if (!normalized.startsWith("/")) {
    normalized = `/${normalized}`;
  }

  normalized = normalized.replace(/\/{2,}/g, "/");

  if (normalized.length > 1 && normalized.endsWith("/")) {
    normalized = normalized.slice(0, -1);
  }

  return normalized || "/";
};

const getPathFromInput = (input) => {
  if (typeof input === "string" && input) {
    try {
      const url = new URL(input, window.location.origin);
      return normalizePath(url.pathname);
    } catch (e) {
      return normalizePath(input);
    }
  }

  return normalizePath(window.location.pathname);
};

const buildRegexFromRoute = (routePattern) => {
  const cleanedPattern = normalizePath(routePattern).replace(/\?/g, "");
  const parts = cleanedPattern.split("/").filter(Boolean);

  if (parts.length === 0) {
    return /^\/$/;
  }

  const escapedParts = parts.map((part) => {
    if (part.startsWith(":")) {
      return "[^/]+";
    }

    return part.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  });

  return new RegExp(`^/${escapedParts.join("/")}$`);
};

const ROUTE_MATCHERS = PAGE_LINKS_WITH_IDS.map((page) => ({
  ...page,
  normalizedLink: normalizePath(page.link),
  regex: buildRegexFromRoute(page.link),
}));

export const getPageIdByPath = (pathOrUrl) => {
  const normalizedPath = getPathFromInput(pathOrUrl);
  const exactMatch = ROUTE_MATCHERS.find((page) => !page.link.includes(":") && page.normalizedLink === normalizedPath);

  if (exactMatch) {
    return exactMatch.id;
  }

  const dynamicMatch = ROUTE_MATCHERS.find((page) => page.regex.test(normalizedPath));

  if (dynamicMatch) {
    return dynamicMatch.id;
  }

  return "not_found";
};

export const getCurrentPageId = () => getPageIdByPath(window.location.href);
export const getPageIdForExternalFile = (pathOrUrl) => getPageIdByPath(pathOrUrl || window.location.href);
export const getDevicePrefix = () => {
  const width = window.innerWidth || window.screen.width || 0;
  return width < 479 ? "mobile" : "web";
};
export const getPageIdWithDeviceByPath = (pathOrUrl) => {
  const pageId = getPageIdByPath(pathOrUrl || window.location.href);
  const devicePrefix = getDevicePrefix();
  return `${devicePrefix}-${pageId}`;
};

export const getCurrentPageIdWithDevice = () => getPageIdWithDeviceByPath(window.location.href);

export const logCurrentPageId = () => {
  const pageIdWithDevice = getCurrentPageIdWithDevice();
  console.log(`[page-id] ${pageIdWithDevice}`);
  return pageIdWithDevice;
};

export const startAutoPageIdLogger = () => {
  if (typeof window === "undefined") {
    return () => {};
  }

  let lastLoggedKey = "";

  const notifyIfChanged = () => {
    const currentPath = normalizePath(window.location.pathname);
    const currentPageIdWithDevice = getPageIdWithDeviceByPath(currentPath);
    const currentKey = `${currentPath}-${currentPageIdWithDevice}`;

    if (currentKey === lastLoggedKey) {
      return;
    }
    lastLoggedKey = currentKey;
    logCurrentPageId();
  };

  const originalPushState = window.history.pushState;
  const originalReplaceState = window.history.replaceState;

  window.history.pushState = function pushStateProxy(...args) {
    const result = originalPushState.apply(this, args);
    notifyIfChanged();
    return result;
  };

  window.history.replaceState = function replaceStateProxy(...args) {
    const result = originalReplaceState.apply(this, args);
    notifyIfChanged();
    return result;
  };

  window.addEventListener("popstate", notifyIfChanged);
  window.addEventListener("hashchange", notifyIfChanged);
  window.addEventListener("resize", notifyIfChanged);

  notifyIfChanged();

  return () => {
    window.history.pushState = originalPushState;
    window.history.replaceState = originalReplaceState;
    window.removeEventListener("popstate", notifyIfChanged);
    window.removeEventListener("hashchange", notifyIfChanged);
    window.removeEventListener("resize", notifyIfChanged);
  };
};

if (typeof window !== "undefined") {
  startAutoPageIdLogger();
}
